import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from "lodash";
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";
import { Trans } from 'react-i18next';

class CheckboxesWithOtherQuestion extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.OnChangeHandler = this.OnChangeHandler.bind(this);
        this.localValidation = debounce(this.localValidation.bind(this), 500);
        this.loadSurvey = debounce(this.loadSurvey.bind(this), 500);
        this.checkResponseSelected = this.checkResponseSelected.bind(this);
        this.checkIfJson = this.checkIfJson.bind(this);
        this.onChangeOther = this.onChangeOther.bind(this);
        this.defaultOtherValue = this.defaultOtherValue.bind(this);

        this.state = {
            errors: {"checkboxes": false, "other_textbox": false, "other_checkboxes": false},
            response: [],
            other_text: ""
        };
    }

    componentDidMount() {
        var self = this;
        var response = self.state.response;

        if(self.props.responses.length > 0)
        {
            self.props.responses.forEach(function (resp, index) {
                response.push({"answer": resp.Response_Choice_Id, "answer_choice": (resp.Answer == null ? "" : resp.Answer)});
            });

            self.setState({
                response: response
            });
        }
    }

    localValidation(e, props) {
        var self = this;
        var response = self.state.response;
        var errors = {"checkboxes": false, "other_textbox": false, "other_checkboxes": false};
        var other_checkboxes = 0;
        
        response.forEach(function (resp, index) {
            if(resp.answer_choice?.split("|")[0].toLowerCase() == "other")
            {
                other_checkboxes++;
            }
        });

        if(jQuery.isEmptyObject(response))
        {
            if($("#required_" + props.question.Id).val() === "true") // check if question is required
            {
                errors.checkboxes = true;
                errors.other_checkboxes = true;

                if($("#answer_other").val() == "")
                {
                    errors.other_textbox = true;
                }
            }
            else if($("#answer_other").val() != "")
            {
                errors.other_checkboxes = true;
            }
        }
        else
        {
            if(other_checkboxes == 0 && $("#answer_other").val() != "")
            {
                errors.other_checkboxes = true; 
            }
            else if(other_checkboxes > 0 && $("#answer_other").val() == "")
            {
                errors.other_textbox = true;
            }
        }

        self.setState({
            errors: errors
        });

        if(!errors.checkboxes && ! errors.other_checkboxes && !errors.other_textbox)
        {
            var response2 = {question_id: props.question.Id, "answer": response};
            props.handleResponse(e, props, response2);
        }
    }

    loadSurvey(e, props, action) {
        props.loadSurvey(e, props, action);
    }

    OnChangeHandler(e, props, option_id, type = "", other = false) {
        var self = this;
        var choice_exists_flag = false;
        var errors = this.state.errors;
        var response = this.state.response;
        var current_response = {};
        var answer_choice = "";
        var other_checkboxes = 0;
        
        if(!other)
        {
            current_response = {"answer": option_id, "answer_choice": type};
        }
        else
        {
            answer_choice = "other|" + type + "|" + ($('#answer_other').val());
            current_response = {"answer": option_id, "answer_choice": answer_choice};
        }

        if(response.length > 0) // check form doesn't already have the response
        {
            response.forEach(function (resp, index) {
                if(resp.answer == option_id && (resp.answer_choice == type || (other && resp.answer_choice?.split("|")[0].toLowerCase() == "other" && resp.answer_choice?.split("|")[1] == type)))
                {
                    choice_exists_flag = true;

                    if(!e.target.checked)
                    {
                        response.splice(index, 1);
                    }
                }

                if(resp.answer_choice?.split("|")[0].toLowerCase() == "other" && e.target.checked)
                {
                    other_checkboxes++;
                }
            });
        }

        if(other && e.target.checked)
        {
            other_checkboxes++;
        }
        
        if(!choice_exists_flag)
        {
            errors.checkboxes = false;

            if(($('#answer_other').val() != "" && other_checkboxes > 0) || ($('#answer_other').val() == "" && other_checkboxes == 0))
            {
                errors.other_textbox = false;
                errors.other_checkboxes = false;
            }

            response.push(current_response);
        }
        else
        {
            if($('#answer_other').val() == "" && other_checkboxes == 0)
            {
                errors.other_textbox = false;
                errors.other_checkboxes = false;
            }
        }

        self.setState({
            response: response,
            errors: errors
        });
    }

    onChangeOther(e, props, option_id) {
        var self = this;
        var errors = self.state.errors;
        var response = this.state.response;
        var other_text = e.target.value;

        if(response.length > 0) // check form doesn't already have the response
        {
            response.forEach(function (resp, index) {
                if(resp.answer == option_id && resp.answer_choice?.split("|")[0].toLowerCase() == "other")
                {
                    response[index].answer_choice = "other|" + response[index].answer_choice?.split("|")[1] + "|" + e.target.value;
                }
            });
        }

        if(e.target.value != "")
        {
            errors.other_textbox = false;
        }

        self.setState({
            response: response,
            other_text: other_text,
            errors: errors
        });
    }

    checkResponseSelected(responses, option, value, checkbox_option = "") {

        var string = "";

        if(!jQuery.isEmptyObject(responses)) {
            $.each(responses, function(i, response){
                if(response.Answer == null || response.Answer?.split("|")[0].toLowerCase() != "other")
                {
                    if(response.Response_Choice_Id == option.Id && (response.Answer == null || response.Answer == checkbox_option))
                    {
                        string = value;
                    }
                }
                else
                {
                    if(response.Response_Choice_Id == option.Id && (response.Answer?.split("|")[1] == "" || response.Answer?.split("|")[1] == checkbox_option)) 
                    {
                        string = value;
                    }
                }
            });
        }

        return string;
    }

    defaultOtherValue(responses)
    {
        var string = "";

        if(!jQuery.isEmptyObject(responses)) {
            $.each(responses, function(i, response){
                if(response.Answer != null && response.Answer?.split("|")[0].toLowerCase() == "other")
                {
                    string = response.Answer?.split("|")[2];
                }
            });
        }

        return string;
    }

    checkIfJson(json) {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }

        return true;
    }
    
    render() {
        return (
            <>
                <div className="registration-main">
                    <div className={"survey-questions-container question-" + (this.props.page)}>
                        <div className="survey-question-text">{ this.props.question.Text }</div>
                        <div className="survey-question-multiselect">
                            {
                                this.checkIfJson(this.props.question.Help_Text) && "options" in (JSON.parse(this.props.question.Help_Text)) ?
                                    <div className="survey-multiselect-option">
                                        <div className="survey-option-name"></div>
                                        {
                                            JSON.parse(this.props.question.Help_Text).options.map((option, index) => (
                                                <div className={"survey-option-checkbox survey-option-" + (index + 1)}>
                                                    { option }
                                                </div>
                                            ))
                                        }
                                        <div className="clearfix"></div>
                                    </div>
                                :
                                    null
                            }
                            {
                                this.props.options.map((option)=>(
                                    option.Text.toLowerCase() != "other" ?
                                        <div className="survey-multiselect-option option-separator" htmlFor={"answer_" + option.Id} key={"checkbox-response-" + option.Id}>
                                            <div className="survey-option-name">{option.Text}</div>
                                            {
                                                this.checkIfJson(this.props.question.Help_Text) && "options" in (JSON.parse(this.props.question.Help_Text)) ?
                                                    <>
                                                        {
                                                            JSON.parse(this.props.question.Help_Text).options.map((checkbox_option, index) => (
                                                                <div className={"survey-option-checkbox survey-option-" + (index + 1)}>
                                                                    <label className="survey-option-checkbox-label">
                                                                        <input type="checkbox" name="answer[]" id={"answer_" + checkbox_option + "_" + option.Id} value={ option.Id } defaultChecked={this.checkResponseSelected(this.props.responses, option, 'checked', checkbox_option)} onChange={(e) => this.OnChangeHandler(e, this.props, option.Id, checkbox_option)}/>
                                                                        <span className={"survey-option-checkbox-custom " + (this.state.errors.checkboxes ? " survey-option-error" : "")}></span>
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </>
                                                :
                                                    <div className="survey-option-checkbox survey-option-1">
                                                        <label className="survey-option-checkbox-label">
                                                            <input type="checkbox" name="answer[]" id={"answer_" + option.Id} value={ option.Id } defaultChecked={this.checkResponseSelected(this.props.responses, option, 'checked')} onChange={(e) => this.OnChangeHandler(e, this.props, option.Id)}/>
                                                            <span className={"survey-option-checkbox-custom " + (this.state.errors.checkboxes ? " survey-option-error" : "")}></span>
                                                        </label>
                                                    </div>
                                            }
                                            <div className="clearfix"></div>
                                        </div>
                                    :
                                        <div className="survey-multiselect-option other-option" htmlFor={"answer_other"}>
                                            <div className="survey-option-name">
                                                <Trans>Other:</Trans>
                                                <input type="text" className={"survey-option-other" + (this.state.errors.other_textbox ? " survey-option-other-error" : "")} name="answer_other" id="answer_other" onChange={(e) => this.onChangeOther(e, this.props, option.Id)} defaultValue={this.defaultOtherValue(this.props.responses)} />
                                                {
                                                    this.state.errors.other_textbox ?
                                                        <div className="survey-errormessage">
                                                            <Trans>*This field is required</Trans>
                                                        </div>
                                                    :
                                                        null
                                                }
                                            </div>
                                            {
                                                this.checkIfJson(this.props.question.Help_Text) && "options" in (JSON.parse(this.props.question.Help_Text)) ?
                                                    <>
                                                        {
                                                            JSON.parse(this.props.question.Help_Text).options.map((checkbox_option, index) => (
                                                                <div className={"survey-option-checkbox survey-option-" + (index + 1)}>
                                                                    <label className="survey-option-checkbox-label">
                                                                        <input type="checkbox" name="answer[]" id={"answer_other_" + checkbox_option + "_" + option.Id} defaultChecked={this.checkResponseSelected(this.props.responses, option, 'checked', checkbox_option)} onChange={(e) => this.OnChangeHandler(e, this.props, option.Id, checkbox_option, true)} />
                                                                        <span className={"survey-option-checkbox-custom " + (this.state.errors.other_checkboxes ? " survey-option-error" : "")}></span>
                                                                    </label>
                                                                </div>
                                                            ))
                                                        }
                                                    </>
                                                :
                                                    <div className="survey-option-checkbox survey-option-1">
                                                        <label className="survey-option-checkbox-label">
                                                            <input type="checkbox" id="answer_checkbox_other" defaultChecked={this.checkResponseSelected(this.props.responses, option, 'checked')} onChange={(e) => this.OnChangeHandler(e, this.props, option.Id, "", true)} />
                                                            <span className={"survey-option-checkbox-custom " + (this.state.errors.other_checkboxes ? " survey-option-error" : "")}></span>
                                                        </label>
                                                    </div>
                                            }
                                            <div className="clearfix"></div>
                                        </div>
                                ))
                            }
                        </div>
                    </div>
                    <input type='hidden' name={'required_' + this.props.question.Id} id={'required_' + this.props.question.Id} value={ (this.props.question.Validation).includes("required") ? true : false }/>
                </div> 

                <div className="registration-actions">
                    {
                        this.props.question.question_orders.length == 0 || this.props.question.question_orders[0].Question_Order != 1 ?
                            <div className="registration-left">
                                <span onClick={(e) => this.loadSurvey(e, this.props, 'previous')} className="primary medium">
                                    <i className="fas fa-arrow-left" style={{marginRight: "20px"}}></i>
                                    <span><Trans>Back</Trans></span>
                                </span>
                            </div>
                        :
                            null
                    }
                    <div className="registration-right">
                        <span onClick={(e) => this.localValidation(e, this.props)} className={"primary medium registration-button " + ((!(this.props.question.Validation).includes("required") || !jQuery.isEmptyObject(this.state.response) || this.state.other_text != "") ? "registration-active" : "disabled")} style={{marginLeft: "20px"}}>
                            <span><Trans>Next</Trans></span>
                            <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                        </span>
                    </div>
                </div>
            </>   
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(CheckboxesWithOtherQuestion);